import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useBreakpoints, useTheme } from '@monorepo/nova-ui';
import NotificationsEmptyImage from '../assets/svg/notifications-empty.svg?react';

export const NotificationsEmpty: FC = () => {
  const { t } = useTranslation(['notificationCenter']);
  const { isMobile } = useBreakpoints();
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height={isMobile ? '100%' : '192px'}
      padding="16px"
      borderRadius="16px"
      sx={{ backgroundColor: palette.background.paper }}
    >
      <Box marginBottom="16px">
        <NotificationsEmptyImage />
      </Box>
      <Typography fontSize={14} fontWeight={500}>
        {t('notificationCenter:no_updates_yet')}
      </Typography>
      <Typography fontSize={14} fontWeight={500}>
        {t('notificationCenter:dive_in_to_get_started')}
      </Typography>
    </Box>
  );
};
